<template>
  <layout :title="pageTitle">
    <section class="section content">
      <div class="search">
        <inertia-link :href="route('project-groups.create')">
          <b-button class="is-primary"> Add Project Group </b-button>
        </inertia-link>
      </div>
      <hr />
      <b-table :data="groups.length ? groups : []">
        <b-table-column
          field="name"
          label="Name"
          v-slot="props"
          sortable
          :searchable="isSearchable"
        >
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="start" label="Projects" v-slot="props" sortable>
          {{ props.row.projects.length }}
        </b-table-column>

        <b-table-column numeric label="Actions" v-slot="props">
          <inertia-link
            :href="route('project-groups.show', props.row.unique_id)"
          >
            <b-button type="is-primary" size="is-small">Edit</b-button>
          </inertia-link>
        </b-table-column>
      </b-table>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  components: {
    Layout,
  },
  props: {
    groups: Array,
  },
  data() {
    return {
      pageTitle: 'Manage Project Groups',
      search_query: { name: '' },
    };
  },
  computed: {
    isSearchable: function () {
      return this.groups.length > 10;
    },
  },
};
</script>
